import { render, staticRenderFns } from "./pbc-table.vue?vue&type=template&id=efa6f778&scoped=true"
import script from "./pbc-table.vue?vue&type=script&lang=js"
export * from "./pbc-table.vue?vue&type=script&lang=js"
import style0 from "./pbc-table.vue?vue&type=style&index=0&id=efa6f778&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa6f778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa6f778')) {
      api.createRecord('efa6f778', component.options)
    } else {
      api.reload('efa6f778', component.options)
    }
    module.hot.accept("./pbc-table.vue?vue&type=template&id=efa6f778&scoped=true", function () {
      api.rerender('efa6f778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/pbc-management/pbc-table.vue"
export default component.exports